// extracted by mini-css-extract-plugin
module.exports = {"section":"k_vRj2w","inner":"k_3dh56","wrap":"k_LQ-9s","listImage":"k_3evvT","item":"k_39htj"};